import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { usePayment } from '../hooks/usePayment';

export default function PaymentCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { executeBkash } = usePayment();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const paymentID = searchParams.get('paymentID');
    const orderId   = searchParams.get('orderId') || localStorage.getItem('yamass_pending_order');
    const gateway   = searchParams.get('gateway') || 'bkash';

    if (!paymentID || !orderId) {
      setStatus('error');
      return;
    }

    const complete = async () => {
      try {
        if (gateway === 'bkash') {
          await executeBkash(paymentID, orderId);
        }
        setStatus('success');
        localStorage.removeItem('yamass_pending_order');
        setTimeout(() => navigate(`/orders/${orderId}`), 2000);
      } catch {
        setStatus('error');
      }
    };

    complete();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-yamass-cream">
      <div className="bg-white rounded-3xl p-12 text-center max-w-md w-full shadow-sm">
        {status === 'processing' && (
          <>
            <div className="w-16 h-16 border-4 border-yamass-accent border-t-transparent rounded-full animate-spin mx-auto mb-6" />
            <h2 className="font-display text-2xl font-bold text-yamass-black mb-2">Processing payment...</h2>
            <p className="text-gray-400 text-sm">Please wait, do not close this page</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-green-600 text-3xl">✓</span>
            </div>
            <h2 className="font-display text-2xl font-bold text-yamass-black mb-2">Payment successful!</h2>
            <p className="text-gray-400 text-sm">Redirecting to your order...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-red-500 text-3xl">✕</span>
            </div>
            <h2 className="font-display text-2xl font-bold text-yamass-black mb-2">Payment failed</h2>
            <p className="text-gray-400 text-sm mb-6">Something went wrong. Please try again.</p>
            <button
              onClick={() => navigate('/orders')}
              className="bg-yamass-black text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-yamass-accent transition-colors"
            >
              View My Orders
            </button>
          </>
        )}
      </div>
    </div>
  );
}
